import { FieldViewModel, IDataLayer, IDataLayerType, IHolding, IOmniaCommand, LayerEditorConfig, LayerViewModel, shell } from "../omnia"

export class EditLayerCmd implements IOmniaCommand {

    layer: IDataLayer

    layerType: IDataLayerType

    holding: IHolding
    targetField: FieldViewModel
    targetCropping: FieldViewModel

    availableLayers: LayerViewModel[]

    config: LayerEditorConfig

    canExecute: (EventTarget: any) => boolean;
    execute: (target: any) => void;

    constructor(protected ctxt: omnia.shell.IComponentLauncher, public text?: string, public icon?: string, public foreground: boolean = false) {
    }

    getEditComponentKey(): string {
        return "omnia-datalayers-layer-edit";
    }

    editLayer(args: {
        target: FieldViewModel,
        holding?: IHolding,
        layer?: IDataLayer,
        layerType?: IDataLayerType,
        availableLayers?: LayerViewModel[],
        config?: LayerEditorConfig
    }): shell.IComponentContext {

        const { target, layer, layerType, holding, availableLayers, config } = args

        this.layer = layer || <any>{}
        this.layerType = layerType

        this.holding = holding;

        if (target) {
            if (target.isCropping()) {
                this.targetField = target.fieldVm
                this.targetCropping = target
            }
            else {
                this.targetField = target
                this.targetCropping = null
            }
        }

        this.availableLayers = availableLayers;

        this.config = config ?? {}

        return this.ctxt.startComponent({ component: this.getEditComponentKey(), execArguments: this });

    }

}
